"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StrategyOrderCell = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./StrategyOrderCell.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StrategyOrderCell = /*#__PURE__*/React.forwardRef(({
  option,
  isLast
}, ref) => {
  const getColor = () => {
    switch (option.statusInfo) {
      case 'Complete':
        return 'aqua';

      case 'Cancelled':
        return 'orange';

      default:
        return 'tan';
    }
  };

  return (0, _pragma.createFelaElement)(_.View, {
    ref: ref,
    flexDirection: "row",
    padding: [4, 0],
    justifyContent: "space-between"
  }, (0, _pragma.createFelaElement)(_.View, {
    padding: [0, 4],
    flexDirection: "column",
    gap: "xsmall",
    alignItems: "center"
  }, option.statusInfo === 'Failed' ? (0, _pragma.createFelaElement)(_.ErrorCircleIcon, {
    color: "background.yellow",
    size: "small"
  }) : (0, _pragma.createFelaElement)(_.CheckboxCheckedIcon, {
    color: "background.".concat(getColor()),
    size: "small"
  }), !isLast && (0, _pragma.createFelaElement)(_.View, {
    css: css.line,
    cssProps: {
      color: getColor()
    }
  })), (0, _pragma.createFelaElement)(_.View, {
    css: css.orderOptionsContainer,
    padding: [0, 0, 8],
    gap: "medium",
    flexDirection: "column"
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: [0]
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "xxsmall",
    alignItems: "flex-start"
  }, (0, _pragma.createFelaElement)(_.View, {
    padding: [0],
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "metaBold",
    color: "text.1",
    align: "left"
  }, option.optionName)), (0, _pragma.createFelaElement)(_.View, {
    padding: [0]
  }, option.metaTextLeft)), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    gap: "xxxsmall",
    justifyContent: "center"
  }, (0, _pragma.createFelaElement)(_.View, {
    inline: true,
    justifyContent: "flex-end",
    margin: [0]
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "metaBold",
    color: "text.1",
    align: "right"
  }, option.statusInfo)), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    align: "right"
  }, option.sideInfo), (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2",
    align: "right"
  }, option.metaTextRight)))));
});
exports.StrategyOrderCell = StrategyOrderCell;
StrategyOrderCell.displayName = 'StrategyOrderCell';
var _default = StrategyOrderCell;
exports.default = _default;
//# sourceMappingURL=StrategyOrderCell.js.map